export default {
  navTitle: "RemindNote",
  home: "Home",
  create: "Create",
  airport: "Airport Transfer",
  recycle: "Recycle Bin",
  setting: "Settings",
  download: "Download",
  feedback: "Feedback",
  login: "Login",
  loginRegister: "Login & Register",
  langSwitch: "Language Switch",
  Payment: "Payment",
  back: "back",
  save: "save",
  Saving: "Saving...",
  clear: "clear",
  newcreate: "newcreate",
  uploadimg: "uploadimg",
  uploadfille: "uploadfille",
  // home
  searchPlaceholder: 'search......',
  Untitled: "Untitled",
  share: "Share",
  txt: "Text",
  img: "Image",
  pdf: "PDF",
  delete: "Delete",
  loading: "loading...",
  // edit
  edit: "edit",
  AddNewRecord: "Add New Record",
  Pleaseenteratitle: "Pleaseenteratitle(up to 150 characters)",
  Pleaseentercontent: "Pleaseentercontent (up to 200,000 characters)",
  Uploadimage: "Upload image(supports PNG, JPEG, up to 20MB each)",
  PasteImage: "Right-click or Ctrl+V to paste the image here...",
  Uploadfiles: "Upload file (supports Word, EXE, APK, compressed files, mp4, msi, TXT, up to 10 files, 50MB each)",
  Theimage: "The image cannot be loaded",
  ImagePreview: "Image Preview",
  Checktheencryptednote: "Check the encrypted note to confirm √ (otherwise the content will be saved without encryption)",
  close: "close",
  file: "Upload File",
  ShareSettings: "Share Settings",
  Setpassword: "Set password (optional)",
  Enterthesharingpassword: "Enter the sharing password",
  Validityperiod: "Validity period:",
  oneDay: "1 day",
  sevenDays: "7 days",
  thirtyDays: "30 days",
  Unlimited: "Unlimited",
  GenerateShareLink: "Generate Share Link",
  Cancel: "Cancel",
  ShareLink: "Share Link:",
  CopyLink: "Copy Link",
  Thefilecannotbeloaded: "The file cannot be loaded:",
};